import * as React from 'react';
import { ModalBody, Modal, ModalFooter, ModalSize, FileUpload, Form, CustomSubmitButton, CustomButton, ButtonType, TextInput, NumberInput, Select } from "soprasteria-ui-library";
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { useFormContext } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';

interface IPhysicalFilesUpload {
    riskPotReportAttachmentCategories: IListItem[];
    name: string;
    required?: boolean;
}

interface IPhysicalFile {
    description: string;
    quantity: number;
    riskPotReportAttachmentCategoryId: number;
}

export const PhysicalFilesUpload: React.FunctionComponent<IPhysicalFilesUpload> = ({ riskPotReportAttachmentCategories, name, required }) => {

    const [file, setFile] = React.useState<IPhysicalFile>({ description: "", quantity: 0, riskPotReportAttachmentCategoryId: 0 });

    const renderWarning = () => {
        var selectedCategory = riskPotReportAttachmentCategories.find((category) => category.value === file.riskPotReportAttachmentCategoryId.toString());
        if (selectedCategory?.informationText) {
            return (
                <div className="col-1" style={{ paddingTop: "27px", paddingLeft: 0, paddingRight: 0 }}>
                    <button className="btn btn-warning btn-sm file-tooltip" id="less" type="button" data-toggle="tooltip" data-placement="right" data-original-title={selectedCategory.informationText}><FontAwesomeIcon icon={faExclamation} /></button>
                </div>
            )
        }
    }

    React.useEffect(() => {
        var myWindow: any = window;
        myWindow.$(`.file-tooltip`).tooltip();
    }, [file.riskPotReportAttachmentCategoryId])

    return (
        <div className="row">
            <TextInput name={`${name}.description`} label="Beskrivning" className="col-6" required={required} />
            <NumberInput name={`${name}.quantity`} label="Antal" className="col-2" required={required} minValue={1} />
            <Select name={`${name}.riskPotReportAttachmentCategoryId`} className="col-3" label="Filtyp" options={riskPotReportAttachmentCategories} required={required} onChange={(val) => setFile({ description: "", quantity: 0, riskPotReportAttachmentCategoryId: parseInt(val) })} />
            {
                renderWarning()
            }
        </div>
    )
}
